<template>
    <div class="body-inner">
        <!-- Section -->
        <section class="fullscreen" data-bg-parallax="images/store-bg.jpg">
            <div class="container">
                <div>
                    <div class="text-center m-b-30">
                        <router-link to="/" class="logo">
                            <img :src="logo" alt="ETC">
                        </router-link>
                        <h1 class="display-3">Recuperar contraseña</h1>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 center p-50 background-white b-r-6">
                            <h3>Iniciar sesión</h3>
                            <vue-form :state="formstate" @submit.prevent="onSubmit">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Usuario</label>
                                            <input class="form-control" placeholder="Correo electrónico" type="email" name="email" id="email" v-model="model.email" required>
                                            <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El correo electrónico es requerido</div>
                                                <div slot="email">El correo electrónico no es válido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                <div class="text-left form-group">
                                    <button type="submit" class="btn">Resetear contraseña</button>
                                </div>
                            </vue-form>
                            <p class="small"><router-link to="/productos">Regresar</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2025 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>        
    </div>
</template>

<script>
/* eslint-disable */
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
  name: 'Login',
  components: {
    
  },
  data() {
      return {
        formstate: {},
        model: {
            email: '',
            password: '',
        },
        hostname: '',
        logo: 'images/logo-etc.png'
      }
  },

  methods: {
    onSubmit() {
        if (this.formstate.$invalid) {
            return;
        } else {
            this.openLoading()
			grecaptcha.execute('6Ldv78EZAAAAAFapAMeP1FaE4JYQDaZhsTskA119')
            .then((token) => {
			    this.model.captchaToken = token
                console.log("captchaToken: " + this.model.captchaToken);

                axios.post(apiKS + 'api/utilerias/password-recovery', this.model, { headers: clientAPI })
                .then( response => {
                    Swal.close()
                    if(response.data.status == true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Exito',
                            text: response.data.message,
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: response.data.message,
                        })
                    }
                }).catch(error => {
                    this.catchError()
                })
            });
        }
    }
  },
  async mounted() {
    const script = document.createElement('script')
    script.src = '/js/functions.js'
    script.id = 'functionScript'
    document.body.appendChild(script)

    this.hostname = hostname

    if(this.hostname == 'storebpo.etciberoamerica.com')
        this.logo = 'images/bpo-login-logo.png'
    if(this.hostname == 'store-conalepon.etciberoamerica.com')
        this.logo = 'images/conalep-logo.png'    
  },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
